import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as models from '../../models'

export const DOC = gql`
  query QueryTreeEditorEdges($tenantId: ID!, $zoneId: ID!, $query: AWSJSON!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        data(query: $query)
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.QueryTreeEditorEdgesQuery,
    readonly models.Edge[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'data',
        graphql.transformers.OUT.pipe(
          graphql.transformers.OUT.json(),
          graphql.transformers.OUT.custom(originalRecords =>
            TypeAsserter.validateButJustWarn(
              originalRecords,
              // adding custom type asserter to ensure the type is an array of Record
              TypeAsserter.Factory.from(
                TypeChecker.Factory.list(models.Edge.isEdge),
                // this will throw a custom error if the type is not correct
                {
                  customError: (tg, value) =>
                    new TypeAsserter.AssertionError({
                      typeDescription: 'mosaic.tree-editor.models.Edge[]',
                      value,
                    }),
                },
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.QueryTreeEditorEdgesQuery,
  readonly models.Edge[],
  graphql.schema.QueryTreeEditorEdgesQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
